/**
 * 위임 로그인(SSO) 진입 파라미터.
 *
 * 개별 서비스가 미로그인 사용자를 여기로 보냅니다:
 *   https://auth.<env>.postdemy.com/login?site=<site_code>&return_to=<서비스 복귀 URL>&state=<서비스 CSRF 값>
 *
 * 콘솔은 이 값을 **해석하지 않습니다 — 전달만 합니다.** 검증(온보딩·복귀 허용·state 형식)은
 * 서버 `/auth/login` 의 책임이고, 불허는 강등 없이 400 으로 거부합니다. open-redirect 방어를
 * 한 지점에 모아 두는 설계이므로 여기서 `return_to` 를 "고쳐 주는" 코드를 넣으면 안 됩니다.
 */

import { CONSOLE_BASE, apiURL } from "./config";
import { currentOrigin, currentSearch } from "./nav";

export interface SsoParams {
  site: string;
  returnTo: string;
  state: string;
  /** 위임 진입 여부 — site 와 return_to 가 **둘 다** 있을 때만 참입니다. */
  isDelegated: boolean;
}

/** ssoParams 는 위임 로그인 파라미터를 URL 에서 그대로 읽습니다. */
export function ssoParams(): SsoParams {
  const q = new URLSearchParams(currentSearch());
  const site = q.get("site") ?? "";
  const returnTo = q.get("return_to") ?? "";
  const state = q.get("state") ?? "";
  return { site, returnTo, state, isDelegated: site !== "" && returnTo !== "" };
}

/** loginURL 은 서버 로그인 진입 URL 을 만듭니다(위임 파라미터 보존). */
export function loginURL({ site, returnTo, state }: Pick<SsoParams, "site" | "returnTo" | "state">): string {
  const q = new URLSearchParams();
  if (site) q.set("site", site);
  if (returnTo) q.set("return_to", returnTo);
  if (state) q.set("state", state);
  if (!site) {
    // 콘솔 흐름 — 로그인 후 갤러리로 돌아옵니다. 절대 URL 을 쓰는 이유는 서버가 이 값을
    // 허용목록(AUTH_RETURN_TO_ALLOWLIST)과 **정확히 일치**로 비교하기 때문입니다.
    q.set("return_to", `${currentOrigin()}${CONSOLE_BASE}/gallery`);
  }
  return apiURL(`/auth/login?${q.toString()}`);
}
